<span *ngIf="trainOption == categoryDiscoveryOption.DialoguesAndCategories.toString()">
  {{ 'AITopic::TopicTrainWithBothStartedMessage' | abpLocalization: dataCount }}
</span>

<span *ngIf="trainOption == categoryDiscoveryOption.OnlyDialogues.toString() || !trainOption">
  {{ 'AITopic::TopicTrainWithDialoguesStartedMessage' | abpLocalization: dataCount }}
</span>

<span *ngIf="trainOption == categoryDiscoveryOption.OnlyCategories.toString()">
  {{ 'AITopic::TopicTrainWithCategoriesStartedMessage' | abpLocalization }}
</span>
